import React, { FC, useEffect, useState } from "react";
import { Button, InputField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useAppraisalTempHook from "../../../hooks/useAppraisalTempHook";

export default ({ item, show, refresh }: any) => {
  var { control, handleSubmit, watch, setValue, getValues } = useForm();
  const rolepickhook = usePickerhook();
  const departmentPickhook = usePickerhook();
  const approvalpickhook = usePickerhook();
  const approvalsTemp = [
    { name: "No approval", code: "noapproal" },
    { name: "Line manager", code: "linemanager" },
    { name: "HR manager", code: "hrmanager" },
    { name: "HR manager & Line manager", code: "hrmanager&linemanager" },
  ];
  const { selectedOrgDepts } = useDepartmentHook();
  const { setLoading } = useStateSetter();
  const [error, seterror] = useState("");
  const [condition, setcondition] = useState(false);
  const watchedFields = watch(["name", "description"]);
  const { SelectedOrg, config } = useStateGetter();
  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" &&
      field !== undefined && 
       approvalpickhook.pickedRole&&
     rolepickhook.pickedRole
   );

  const { updateAppTempinfo } = useAppraisalTempHook();

  //Set default values for fields
  useEffect(() => {
    setValue("name", item.name);
    setValue("description", item.desc);
    departmentPickhook.setPickedRole({
      code: item.deptID,
      name: selectedOrgDepts.filter((kk: any) => kk.id == item.deptID)[0]
        ?.deptName,
    });
    rolepickhook.setPickedRole({ name: item.role, code: item.role });
    approvalpickhook.setPickedRole({
      name: item.approval,
      code: approvalsTemp.filter((kg: any) => kg.name == item.approval)[0],
    });
  }, []);

  const onSubmit = async (data: any) => {
    var postdata = {
      name: data.name,
      role: rolepickhook.pickedRole.name,
      approval: approvalpickhook.pickedRole.name,
      desc: data.description,
    };
    setLoading(true);

    var response = await updateAppTempinfo(item.id, postdata);

    show(false);
    setLoading(false);
    refresh();
  };

  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col    rounded-[8px] bg-white w-[40vw] p-4 ">
          <p className="font-semibold self-start text-sm ">Edit Template</p>
          <div className="   	 ">
            <InputField
              name="name"
              title="Name"
              placeholder={"Enter Template Name"}
              control={control}
              rules={{
                required: "name is required",
                pattern: {
                  value: textReg,
                  message: "Invalid name",
                },
              }}
            />

            {/* <ListPicker
              fullwidth
              hook={departmentPickhook}
              title="Department"
              list={selectedOrgDepts.map((i) => {
                return { name: i.deptName, code: i.id };
              })}
            /> */}

            <ListPicker
              fullwidth
              hook={rolepickhook}
              title="Role"
              list={[
                { name: "Employee", code: "employee" },
                { name: "Line manager", code: "line manager" },
              ]}
            />

            <ListPicker
              fullwidth
              hook={approvalpickhook}
              title="Approval"
              list={approvalsTemp}
            />

            <InputField
              name="description"
              title="Template description"
              placeholder={"Enter description"}
              isTextArea
              control={control}
              rules={{
                required: "description is required",
                pattern: {
                  value: textReg,
                  message: "Invalid description",
                },
              }}
            />
          </div>

          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                show(false);
              }}
            />

            <Button
              disabled={!areFieldsFilled}
              text="Save Changes"
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
